module.exports = __webpack_public_path__ + "static/media/07_twitter_image.c629b6ee.jpg";